// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host .plain-text {\n  width: 100%;\n}\n:host .plain-text textarea {\n  height: calc(100vh - 400px);\n}\n:host .add-category {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  padding-top: 10px;\n}\n:host .add-category-title {\n  flex-grow: 1;\n}\n:host ::ng-deep .mat-tab-body-wrapper {\n  padding-top: 20px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
